import React from 'react'
import { Box } from '@mui/material'

// Avoid horizontal scrollbar widen the width so that a vertical scrollbar is added when children contains DataGrid
export const FluentWidthContainer = ({
    children,
    minWidth,
}: {
    children: React.ReactNode
    minWidth?: number | string
}) => <Box sx={{ minWidth, maxWidth: 'calc(100% - 20px)' }}>{children}</Box>
